<div
  class="section-container"
  [class.showKeyframeIndicator]="showKeyframeIndicator"
>
  <div
    *ngFor="let section of sections$ | async; trackBy: trackByIndex"
    class="section visibility-{{ section.visibility }}"
    [style.left.%]="section.left"
    [style.width.%]="section.width"
    [class.keyframe-indicator]="showKeyframeIndicator"
  >
    <div
      *ngIf="section.mlExtrapolationWidth"
      class="ml-section"
      [style.left.%]="section.left"
      [style.width.%]="section.mlExtrapolationWidth"
    ></div>
  </div>
  <ng-container *ngIf="showKeyframeIndicator">
    <div
      *ngFor="let frame of dynamicKeyframes$ | async"
      class="dynamic-keyframe"
      [class.blank-required]="frame.blankRequired"
      [style.left.%]="frame.frameNumberPercent"
    ></div>
  </ng-container>
  <div
    *ngFor="let request of pendingExtrapolationSections$ | async"
    class="section ml-loading"
    [style.left.%]="request.left"
    [style.width.%]="request.width"
  ></div>
</div>
